import React, { Component } from 'react';
import PropTypes from 'prop-types';
import debounce from 'debounce';

// Utils
import { isTrue } from 'utils/varValidation';

import './ServiceTextBox.scss';
const ns = 'service-text-box';

class ServiceTextBox extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(text) {
    const {
      tellusmoreSvcId,
      services,
      addService,
      updateTellusmoreService,
      removeService
    } = this.props;
    if (text) {
      const addedService = {
        id: tellusmoreSvcId,
        notes: text,
        name: text,
        price: 0
      };
      const findCallback = serviceArray => serviceArray.id === tellusmoreSvcId;
      if (!services.find(findCallback)) {
        addService(addedService);
      } else {
        updateTellusmoreService(addedService);
      }
    } else {
      removeService(tellusmoreSvcId);
    }
  }

  render() {
    const {
      services,
      tellusmoreSvcId,
      tellusmoreSvcVisible,
      intl
    } = this.props;
    const findCallback = ({ id }) => id === tellusmoreSvcId;
    const { notes, name } = services.find(findCallback)
      ? services.find(findCallback)
      : '';
    const textareaChange = debounce(text => this.handleChange(text), 600);
    return isTrue(tellusmoreSvcVisible) ? (
      <div className={ns}>
        <div className={`${ns}__label`}>
          {intl.formatMessage({
            id: 'c8.services.page.tellusmore.label'
          })}
        </div>
        <textarea
          className={`${ns}__tell-us-more`}
          onChange={ev => textareaChange(ev.target.value)}
          placeholder={intl.formatMessage({
            id: 'c8.services.page.tellusmore.placeholder'
          })}
          defaultValue={notes || name}
          id="tellus_more_texbox"
          maxLength="250"
          aria-label={intl.formatMessage({
            id: 'c8.aria.type.in.more.info',
            defaultMessage: 'Type In More Information'
          })}
          tabIndex={0}
        />
      </div>
    ) : null;
  }
}

ServiceTextBox.propTypes = {
  addService: PropTypes.func.isRequired,
  intl: PropTypes.object,
  notes: PropTypes.object,
  removeService: PropTypes.func.isRequired,
  services: PropTypes.array,
  tellusmoreSvcId: PropTypes.number.isRequired,
  tellusmoreSvcVisible: PropTypes.string.isRequired,
  updateTellusmoreService: PropTypes.func.isRequired
};

export default ServiceTextBox;



// WEBPACK FOOTER //
// ./src/components/atoms/ServiceTextBox/ServiceTextBox.js